import { gql } from 'apollo-angular';

export const RemoveProfileDocument = gql`
  mutation removeProfile {
    removeProfile
  }
`;
